<template>
  <div class="row h-100">
    <div class="col-12 h-100">
      <UpsertItem id="add-item-modal" :get-page="getPage" title="New List Item" :list-id="id" />
      <UpsertItem
        id="edit-item-modal"
        :get-page="getPage"
        title="Edit List Item"
        :init-data="selectedItem"
        :on-save="() => (selectedItem = {})"
        type="edit"
        :list-id="id"
      />
      <div v-if="loaded" class="poppins h-100 d-flex flex-column" style="padding-bottom: 20px">
        <div class="inputs-block">
          <BlockHeader name="Details" />
          <div class="row">
            <div class="col-lg-5 col-sm-12 col-xs-12">
              <Input v-model="name" form-group-id="name" placeholder="name" required />
            </div>
            <div class="col-lg-5 col-sm-12 col-xs-12">
              <Input v-model="description" form-group-id="description" placeholder="description" />
            </div>
            <div class="col-lg-2 col-sm-12 col-xs-12 save-wrapper pt-1">
              <b-button
                v-if="isCommonAdmin"
                variant="primary"
                size="lg"
                class="mt-4"
                :disabled="!name || isSubmitting || !isChangedFields"
                @click="onSubmit"
              >
                {{ id ? 'update_details' : 'create_list' | i18n }}
              </b-button>
            </div>
          </div>
        </div>
        <div class="inputs-block overflow-hidden d-flex flex-column" v-if="id" style="margin-top: 20px">
          <div class="item-block">
            <div class="add-item-block">
              <div class="header">Items</div>
              <b-button v-b-modal.add-item-modal variant="primary" size="sm" style="height: 33px; padding: 0px 10px" v-if="isCommonAdmin">
                <BIconPlus />{{ 'add_list_item' | i18n }}
              </b-button>
            </div>
            <div class="delete-all-btn">
              <b-button @click="deleteAllItems" variant="danger" size="sm" style="height: 33px; padding: 0px 10px" v-if="isCommonAdmin">
                {{ 'delete_all_list_items' | i18n }}
              </b-button>
            </div>
          </div>
          <div class="filter-block">
            <SearchInput :searchChange="searchChange" />
          </div>
          <Table
            :update="getPage"
            :columns="columns"
            :rows="rows"
            :filter="filter"
            :updateFilter="updateFilter"
            :loadingInstance="loadingInstance"
            :setLoadingInstance="setLoadingInstance"
            :selectedList="selectedList"
            :setSelectedList="setSelectedList"
            class="overflow-auto pr-1"
            tableName="listDetailsTable"
          />
        </div>
      </div>
      <Loader v-else />
    </div>
  </div>
</template>
<script>
import { BIconPencil, BIconTrash, BIconPlus } from 'bootstrap-vue';

import Input from '../../common/input';
import { ListMixin, NotificationMixin, DeleteRowMixin, AuthMixin } from '../../../../mixins';
import BlockHeader from '../../common/block-header';
import PageHeader from '../../common/page-header';
import Loader from '../../common/loader';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import UpsertItem from './upsert-item';

let inputInterval = null;

export default {
  title: 'Add list',
  components: { Input, BlockHeader, BIconPencil, BIconTrash, PageHeader, Loader, Table, SearchInput, BIconPlus, UpsertItem },
  mixins: [ListMixin, NotificationMixin, DeleteRowMixin, AuthMixin],
  data() {
    return {
      selectedList: [],
      loaded: false,
      name: '',
      description: '',
      id: '',
      selectedItem: {},
      itemsCount: 1,
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
      },
      loadingInstance: null,
      isSubmitting: false,
      initialData: {},
      columns: [
        {
          field: 'identifier',
          title: this.$translate('Identifier'),
          key: '1',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'title',
          title: this.$translate('Title'),
          key: '2',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'subtitle',
          title: this.$translate('subtitle'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'content',
          title: this.$translate('content'),
          key: '4',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'actions',
          title: '',
          key: '5',
          width: 90,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                {this.isCommonAdmin && (
                  <div class="copy-button" on-click={() => this.editItem(row)}>
                    {this.$translate('edit')}
                  </div>
                )}
                {this.isCommonAdmin && (
                  <div class="download-button delete-button" on-click={() => this.deleteItem(row)}>
                    {this.$translate('delete')}
                  </div>
                )}
              </div>
            );
          },
        },
      ],
      rows: [],
    };
  },
  computed: {
    isChangedFields: function () {
      if (!Object.keys(this.initialData).length) return true;
      let result = false;
      Object.keys(this.initialData).forEach((key) => {
        if (this[key] !== this.initialData[key]) {
          result = true;
        }
      });
      return result;
    },
  },
  async created() {
    this.id = this.$route.params.id;
    if (this.id) {
      const listResponse = await this.listService.getById(this.id);
      const data = listResponse.data;

      this.name = data.name;
      this.description = data.description;

      this.initialData.name = data.name;
      this.initialData.description = data.description;
    }
    this.loaded = true;
  },
  methods: {
    async editItem(item) {
      this.selectedItem = item;
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'edit-item-modal');
      }, 100);
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        if (!this.id) {
          return;
        }
        this.startLoading();
        const { page, limit, sortBy, sortOrder, status, dateRange, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (status) {
          ctx.status = status;
        }
        if (dateRange && dateRange.startDate && dateRange.endDate) {
          ctx.startDate = dateRange.startDate;
          ctx.endDate = dateRange.endDate;
        }
        const response = await this.listService.getItemsById(this.id, ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async deleteItem(item) {
      await this.deleteSelectedRows(null, async () => {
        try {
          await this.listService.removeItem(this.id, item.id);
          await this.getPage();
          this.showNotification({ type: 'success', message: this.$translate('success') });
        } catch (err) {
          this.showNotification({ type: 'error', message: err.message });
        }
      });
    },
    async deleteAllItems() {
      await this.deleteSelectedRows(null, async () => {
        try {
          await this.listService.removeAllItems(this.id);
          await this.getPage();
          this.showNotification({ type: 'success', message: this.$translate('success') });
        } catch (err) {
          this.showNotification({ type: 'error', message: err.message });
        }
      });
    },
    async onSubmit() {
      try {
        this.isSubmitting = true;
        const payload = {
          name: this.name,
          description: this.description,
        };
        if (this.id) {
          payload.id = this.id;
          await this.listService.update(payload);
        } else {
          const result = await this.listService.create(payload);
          this.$router.push({ name: 'list-details', params: { id: result.id } });
          this.id = result.id;
        }
        this.initialData = payload;
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #add-team .modal-dialog {
  max-width: 700px !important;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.header {
  color: #5f5f5f !important;
  font-size: 1.6rem !important;
  font-weight: 400;
  text-transform: uppercase;
  margin-right: 20px;
}

.item-text {
  color: #5f5f5f !important;
  font-size: 1.2rem !important;
  font-weight: 400;
  margin-left: 20px;
  margin-top: 10px;
}

.header-block {
  width: 100%;
  display: flex;
  align-items: center;
}

.add-item-block {
  display: flex;
}

.item-block {
  display: flex;
  margin-bottom: 30px;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.delete-all-btn {
  display: flex;
  align-items: flex-end;
}

.action-block {
  display: flex;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
  cursor: pointer;
}

::v-deep .delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
}

.save-wrapper {
  display: flex;
  flex-direction: column;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 30px;
}
</style>
